module.exports = __webpack_public_path__ + "img/utility_sync_1.31191d6d.jpg";